export { AddProofDocUpload } from './add-proof-doc-upload.component';
